import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBK5xL44MILgHvNxq6nzT3-JUVjnd2OPuU",
  authDomain: "acceso7-32ad3.firebaseapp.com",
  projectId: "acceso7-32ad3",
  storageBucket: "acceso7-32ad3.firebasestorage.app",
  messagingSenderId: "743099229873",
  appId: "1:743099229873:web:02901ad3a63b14f5b5a490",
  measurementId: "G-NN3H25VGQL"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();

// Configurar Google Auth
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Configurar para producción
if (typeof window !== 'undefined') {
  // Configurar CORS para Google Auth en producción
  auth.settings.appVerificationDisabledForTesting = false;
  
  // Configurar headers para evitar problemas de CORS
  auth.settings.appVerificationDisabledForTesting = false;
}

export default app;
